import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceComponent, debounce} from "dce-engine";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";

interface SelectShowProps {

}

/**
 * Pokazywanie odpowiedniego div;a na podstawie wybranej wartości
 */
@Dce("SelectShow")
export default class SelectShow extends DceComponent<SelectShowProps> {

    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: SelectShowProps) {
        super(elem, props);
        this.parentFragment = findFragmentParent(elem);

        elem.addEventListener('change', e => {
            this.updateDisplay();
        });

        this.updateDisplay();
    }

    private updateDisplay(){
        let v = (this.elem as unknown as HTMLSelectElement).value;

        this.parentFragment.updateDisplay(
            '*[data-show-id]', 'none'
        );

        this.parentFragment.updateDisplay(
            '*[data-show-id="' + v + '"]', 'block'
        );
    }
}